import {
  Box,
  Typography,
  Card,
  CardContent,
  CardMedia,
  Skeleton,
} from "@mui/material";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

import LondonViewImg from "../../../assets/images/london-view.jpg";
// Import badges
import SilverBadge from "../../../assets/images/badges/silver.svg";
import PlatinumBadge from "../../../assets/images/badges/platinum.svg";
import GoldBadge from "../../../assets/images/badges/gold.svg";
import BronzeBadge from "../../../assets/images/badges/bronze.svg";

import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { useState, useEffect } from "react";
import axiosInstance from "../../../axiosInstance";

// Banner API interface
// interface BannerData {
//   banner_id: number;
//   title: string;
//   image: string;
//   order: number;
// }

// interface BannerApiResponse {
//   count: number;
//   page: number;
//   page_size: number;
//   banners: BannerData[];
// }

// Dynamic slides configuration - OLD STATIC STRUCTURE (COMMENTED OUT)
/*
const slidesData: SlideData[] = [
  {
    id: "property-2",
    type: "image-link",
    title: "Property",
    images: {
      mobile: Property2Desktop,
      desktop: Property2Mobile,
    },
    link: {
      url: "https://londonist.co.uk/residences/drapery-place_531?academic_year_id=9",
      target: "_blank",
    },
    hasGradient: true,
  },
  {
    id: "property",
    type: "image-link",
    title: "Property",
    images: {
      mobile: PropertyDesktop,
      desktop: PropertyMobile,
    },
    link: {
      url: "https://londonist.co.uk/residences/london-bridge-residence_537",
      target: "_blank",
    },
    hasGradient: true,
  },
  {
    id: "flexible-stay",
    type: "image-link",
    title: "Flexible Stay",
    images: {
      mobile: FlexibleMobile,
      desktop: FlexibleDesktop,
    },
    link: {
      // url: "#",
      // target: "_blank",
    },
    hasGradient: true,
  },
  {
    id: "special-offer",
    type: "image-link",
    title: "Special Offer",
    images: {
      mobile: SpecialOfferMobile,
      desktop: SpecialOfferDesktop,
    },
    link: {
      // url: "#",
      // target: "_blank",
    },
    hasGradient: true,
  },
  {
    id: "dmc-enter-london",
    type: "image-link",
    title: "Enter London",
    images: {
      mobile: DmcEnterLondonMobile,
      desktop: DmcEnterLondonDesktop,
    },
    link: {
      url: "https://londonist.co.uk/landing-student/enter-london",
      target: "_blank",
    },
    hasGradient: true,
  },
  {
    id: "book-the-gap",
    type: "image-link",
    title: "Book the Gap",
    images: {
      mobile: BookGapMobile,
      desktop: BookGapDesktop,
    },
    link: {
      url: "https://landing.londonist.co.uk/book-the-gap",
      target: "_blank",
    },
    hasGradient: true,
  },
  {
    id: "kings-award-for-enterprise",
    type: "image-link",
    title: "Kings Award for Enterprise",
    images: {
      mobile: KingsAwardsMobile,
      desktop: KingsAwardsDesktop,
    },
    link: {
      url: "https://londonist.co.uk/news/londonist-dmc-receives-the-2025-kings-award-for-enterprise",
      target: "_blank",
    },
    hasGradient: true,
  },
  {
    id: "any-interns",
    type: "image-link",
    title: "Any Interns",
    images: {
      mobile: AnyInternsMobile,
      desktop: AnyInternsDesktop,
    },
    link: {
      url: "https://londonist.co.uk/any-interns",
      target: "_blank",
    },
    hasGradient: true,
  },
  {
    id: "soundon",
    type: "image-link",
    title: "Sound On",
    images: {
      mobile: SoundonMobile,
      desktop: SoundonDesktop,
    },
    link: {
      url: "#",
      target: "_blank",
    },
    hasGradient: true,
  },
  {
    id: "rise-shine",
    type: "image-link",
    title: "Rise and Shine",
    images: {
      mobile: RiseShineMobile,
      desktop: RiseShineDesktop,
    },
    link: {
      url: "https://londonist.co.uk/blogs/rise-and-shine-londonist-family",
      target: "_blank",
    },
    hasGradient: true,
  },
  {
    id: "flexible-stays",
    type: "image",
    title: "Flexible Stays",
    images: {
      mobile: FlexibleStaysMobile,
      desktop: FlexibleStaysDesktop,
    },
    hasGradient: true,
  },
  {
    id: "kayak",
    type: "image-link",
    title: "Kayak",
    images: {
      mobile: KayakDesktopSm,
      desktop: KayakDesktop,
    },
    link: {
      url: "https://www.kayak.co.uk/?utm_source=tradetracker&utm_medium=affiliate&utm_campaign=472424&utm_content=32925",
      target: "_blank",
    },
    hasGradient: true,
  },
  {
    id: "fifty",
    type: "image-link",
    title: "Fifty",
    images: {
      mobile: FiftyMobile,
      desktop: FiftyDesktop,
    },
    link: {
      url: "#",
      target: "_blank",
    },
    hasGradient: true,
  },
  {
    id: "no-deposit",
    type: "image",
    title: "No Security Deposit",
    images: {
      mobile: NoDepositMobile,
      desktop: NoDepositDesktop,
    },
    hasGradient: true,
  },
  {
    id: "start-smart",
    type: "image-link",
    title: "Start Smart",
    images: {
      mobile: StartSmartMobile,
      desktop: StartSmartDesktop,
    },
    link: {
      url: "#",
      target: "_blank",
    },
    hasGradient: true,
  },
  {
    id: "jet-stay",
    type: "image",
    title: "Jet Stay",
    images: {
      mobile: JetStayMobile,
      desktop: JetStayDesktop,
    },
    hasGradient: true,
  },
  {
    id: "five-star-five-year",
    type: "image-link",
    title: "Five Star Five Year",
    images: {
      mobile: FiveStartFiveYearMobile,
      desktop: FiveStartFiveYearDesktop,
    },
    link: {
      url: "#",
      target: "_blank",
    },
    hasGradient: true,
  },
  {
    id: "share-the-room",
    type: "image",
    title: "Share The Room",
    images: {
      mobile: ShareTheRoomMobile,
      desktop: ShareTheRoomDesktop,
    },
    hasGradient: true,
  },
  {
    id: "xmas-gift",
    type: "image-link",
    title: "Christmas Gift",
    images: {
      mobile: XmaxGiftMobile,
      desktop: XmaxGiftDesktop,
    },
    link: {
      url: "#",
      target: "_blank",
    },
    hasGradient: true,
  },
  {
    id: "black-friday",
    type: "image",
    title: "Black Friday",
    images: {
      mobile: BlackFridayMobile,
      desktop: BlackFridayDesktop,
    },
    hasGradient: true,
  },
  {
    id: "youtube-video",
    type: "video",
    title: "YouTube Video",
    images: {
      mobile: "",
      desktop: "",
    },
    video: {
      embedUrl: "https://www.youtube.com/embed/t_jmqnFsKkw?si=IOpd7I-jqlscYcTT",
      title: "Embedded YouTube Video",
    },
    hasGradient: true,
  },
];
*/

// NEW DYNAMIC SLIDES DATA - USING ONLY BANNERS FROM API
// const slidesData: SlideData[] = []; // Empty array since we're using banners from API

const SliderTopArea = () => {
  const { t } = useTranslation();

  const lightMode = useSelector((state: any) => state.mode.lightMode);
  const profile = useSelector((state: any) => state.profile);

  // NEW STATE FOR BANNERS
  const [banners, setBanners] = useState([]);
  const [bannersLoading, setBannersLoading] = useState(true);
  const [bannersError, setBannersError] = useState(null);

  // NEW FUNCTION TO FETCH BANNERS
  const fetchBanners = async () => {
    try {
      setBannersLoading(true);
      setBannersError(null);

      // Get authentication tokens from localStorage
      let accessToken = localStorage.getItem("accessToken");
      let token = localStorage.getItem("loginUser");

      const response = await axiosInstance.get('dashboard/banners', {
        headers: {
          Authorization: `Bearer ${accessToken}`, // Bearer token
          XRefreshToken: `${token}`, // XRefreshToken
          "Content-Type": "application/json",
        },
      });

      if (response.data && response.data.banners) {
        setBanners(response.data.banners);
      }
    } catch (error) {
      console.error('Error fetching banners:', error);
      setBannersError('Failed to load banners');
    } finally {
      setBannersLoading(false);
    }
  };

  // NEW USE EFFECT TO FETCH BANNERS
  useEffect(() => {
    fetchBanners();
  }, []);

  // NEW FUNCTION TO CONVERT BANNERS TO SLIDES
  const convertBannersToSlides = () => {
    return banners.map((banner) => ({
      id: `banner-${banner.banner_id}`,
      type: banner.type,
      video_id: banner.video_id,
      title: banner.title,
      redirect_url: banner.redirect_url,
      images: {
        mobile: banner.mobile_image,
        desktop: banner.image,
      },
      hasGradient: true,
    }));
  };

  // NEW FUNCTION TO GET FINAL SLIDES (BANNERS ONLY)
  const getFinalSlides = () => {
    const bannerSlides = convertBannersToSlides();

    console.log(bannerSlides, 'bannerSlides');

    return bannerSlides; // Only banners from API, no static slides
  };

  // Function to get badge image based on profile
  const getBadgeImage = () => {
    const badge = profile?.profile?.badge?.toLowerCase();
    if (badge?.includes("gold")) return GoldBadge;
    if (badge?.includes("silver")) return SilverBadge;
    if (badge?.includes("platinum")) return PlatinumBadge;
    if (badge?.includes("bronze")) return BronzeBadge;
    return null;
  };

  // NEW FUNCTION TO RENDER SKELETON LOADING
  const renderSkeletonSlides = () => {
    return Array.from({ length: 3 }).map((_, index) => (
      <SwiperSlide key={`skeleton-${index}`}>
        <Box
          sx={{
            width: "100%",
            height: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            background: lightMode ? "#f5f5f5" : "#424242",
          }}
        >
          <Skeleton
            variant="rectangular"
            width="100%"
            height="100%"
            animation="wave"
            sx={{ borderRadius: ".5rem" }}
          />
        </Box>
      </SwiperSlide>
    ));
  };

  // Function to render slide content based on type
  const renderSlideContent = (slide) => {
    const gradientOverlay = slide.hasGradient
      ? {
        "&::before": {
          content: '""',
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          backgroundImage: `linear-gradient(to bottom, transparent 0%, rgba(0, 0, 0, 70%) 100%)`,
          zIndex: 1,
          pointerEvents: "none",
          borderRadius: ".5rem",
        },
      }
      : {};

    const baseBoxStyles = {
      position: "relative",
      width: "100%",
      height: "100%",
      ...gradientOverlay,
    };

    function getYoutubeEmbedUrl(video_id) {
      console.log(video_id, 'video_id');
      
      if (!video_id || video_id.trim() === "") return null;
      return `https://www.youtube.com/embed/${video_id}`;
    }
    
    
    switch (slide.type) {
      case "video":
        return (
          <Box sx={baseBoxStyles}>
            <Card
              sx={{
                height: "100%",
                width: "100%",
                borderRadius: ".5rem",
                position: "relative",
                zIndex: 0,
              }}
            >
              <CardMedia
                component="iframe"
                style={{ borderRadius: ".5rem" }}
                height="100%"
                src={getYoutubeEmbedUrl(slide?.video_id)}
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                title={slide.title}
              />
            </Card>
          </Box>
        );

      case "image-link":
        return (
          <Box sx={baseBoxStyles}>
            <Link
              to={slide?.redirect_url || "#"}
              target={slide?.redirect_url || "_self"}
              style={{
                width: "100%",
                height: "100%",
                position: "relative",
                zIndex: 0,
              }}
            >
              <img
                src={
                  window?.innerWidth < 768
                    ? slide.images.mobile
                    : slide.images.desktop
                }
                style={{
                  borderRadius: ".5rem",
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                }}
                alt={slide.title || ""}
              />
            </Link>
          </Box>
        );

      case "image":
      default:
        return (
          <Box sx={baseBoxStyles}>
            <Box
              style={{
                width: "100%",
                height: "100%",
                position: "relative",
                zIndex: 0,
              }}
            >
              <img
                src={
                  window?.innerWidth < 768
                    ? slide.images.mobile
                    : slide.images.desktop
                }
                style={{
                  borderRadius: ".5rem",
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                }}
                alt={slide.title || ""}
              />
            </Box>
          </Box>
        );
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: { xs: "column", lg: "row" },
        maxHeight: { xs: "auto", lg: 400 },
        gap: 2,
        p: 0,
        fontFamily: "Inter, -apple-system, BlinkMacSystemFont, sans-serif",
      }}
    >

      {/* Left Welcome Section */}
      <Card
        sx={{
          flex: 2,
          backgroundImage: `linear-gradient(to right, rgba(20, 26, 33, 0.88) 0%, #305890 95%),url(${LondonViewImg})`,

          backgroundPosition: "center",
          borderRadius: "20px",
          border: "none",
          boxShadow: "0 8px 32px rgba(0, 0, 0, 0.3)",
          position: "relative",
          overflow: "hidden",
        }}
      >

        {/*   <Box display={"flex"}>
          <Button variant="contained" onClick={() => {
            // Warning/Delete confirmation
            Swal.fire({
              icon: 'warning',
              title: 'Are you sure?',
              text: "You're about to delete your account. This action cannot be undone.",
              showCancelButton: true,
              confirmButtonText: 'Yes, Delete',
              cancelButtonText: 'Cancel',
              customClass: {
                confirmButton: 'swal2-delete'
              }
            });
          }}>Warning</Button>

          <Button variant="contained" onClick={() => {
            // Info/Reminder
            Swal.fire({
              icon: 'info',
              title: 'Reminder',
              text: 'To apply these changes, you\'ll need to refresh your preferences.',
              confirmButtonText: 'Update Settings'
            });
          }}>Info Reminder</Button>

          <Button variant="contained" onClick={() => {
            // Error
            Swal.fire({
              icon: 'error',
              title: 'Something went wrong?',
              text: 'We couldn\'t complete your request due to a server error. Please try again.',
              confirmButtonText: 'Retry'
            });
          }}>Error</Button>

          <Button variant="contained" onClick={() => {
            // Success
            Swal.fire({
              icon: 'success',
              title: 'Payment Successful!',
              text: 'Thank you! Your transaction is complete.',
              confirmButtonText: 'View Receipt'
            });
          }}>Success</Button>

          <Button variant="contained" onClick={() => {
            // Delete user with custom styling
            Swal.fire({
              title: 'Delete user?',
              html: 'Are you sure you want to delete <strong>this</strong> user?<br>Once deleted, all associated data will be permanently lost.',
              showCancelButton: false,
              confirmButtonText: 'Yes, Delete',
              customClass: {
                confirmButton: 'swal2-delete'
              }
            });
          }}>Delete User</Button>
        </Box> */}
        <CardContent
          sx={{
            p: 4,
            height: "100%",
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "space-between",
            position: "relative",
            zIndex: 2,
          }}
        >
          <Box>
            <Typography
              variant="h4"
              sx={{
                color: "white",
                fontWeight: 600,
                mb: 1,
                fontSize: "2rem",
                lineHeight: 1.2,
                textTransform: 'capitalize'
              }}
            >
              {/* {t("welcomeBack")} 👋 */}
              {t("welcomeBack")} 👋
            </Typography>
            <Typography
              variant="h5"
              sx={{
                textTransform: 'capitalize',
                color: "white",
                fontWeight: 500,
                mb: 3,
                fontSize: "1.5rem",
              }}
            >
              {profile?.profile?.agent_name}
            </Typography>
            <Typography
              variant="body1"
              sx={{
                color: "rgba(255, 255, 255, 0.7)",
                mb: 4,
                fontSize: "1rem",
                lineHeight: 1.6,
                maxWidth: "280px",
              }}
            >
              {/* {t("tagline")} */}
              {t("tagline")}
            </Typography>
          </Box>

          {/* Character Illustration */}
          <Box
            sx={{
              position: "relative",
              marginLeft: "auto",
              zIndex: 1,
            }}
          >
            {getBadgeImage() && (
              <Box
                sx={{
                  width: 200,
                  height: 200,
                  background: `url(${getBadgeImage()})`,
                  backgroundSize: "contain",
                  backgroundRepeat: "no-repeat",
                  backgroundPosition: "center",
                }}
              />
            )}
          </Box>
        </CardContent>
      </Card>

      {/* Right Carousel Section */}
      <Card
        sx={{
          flex: 1,
          borderRadius: "20px",
          border: "none",
          boxShadow: "0 8px 32px rgba(0, 0, 0, 0.3)",
          overflow: "hidden",
          position: "relative",
        }}
      >
        <Swiper
          modules={[Navigation, Pagination]}
          navigation={{
            prevEl: ".swiper-button-prev-custom",
            nextEl: ".swiper-button-next-custom",
          }}
          pagination={{
            clickable: true,
            bulletClass: "swiper-pagination-bullet-custom",
            bulletActiveClass: "swiper-pagination-bullet-active-custom",
            renderBullet: (index, className) => {
              return `<span class="${className}"></span>`;
            },
          }}
          spaceBetween={0}
          slidesPerView={1}
          style={{ height: "100%" }}
        >
          {/* NEW DYNAMIC RENDERING WITH LOADING STATE */}
          {bannersLoading ? (
            renderSkeletonSlides()
          ) : bannersError ? (
            // Fallback to static slides if banner API fails
            // OLD STATIC SLIDES - UNCOMMENT TO USE
            /*
            slidesData.map((slide) => (
              <SwiperSlide
                key={slide.id}
                style={{
                  userSelect: "none",
                  background: lightMode ? "#ffffff" : "#343434",
                }}
              >
                {renderSlideContent(slide)}
              </SwiperSlide>
            ))
            */
            // Show error message instead
            <SwiperSlide>
              <Box
                sx={{
                  width: "100%",
                  height: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  background: lightMode ? "#f5f5f5" : "#424242",
                  color: lightMode ? "#666" : "#fff",
                }}
              >
                <Typography variant="body2">
                  {bannersError}
                </Typography>
              </Box>
            </SwiperSlide>
          ) : (
            // Render dynamic slides (banners only)
            getFinalSlides().map((slide) => (
              <SwiperSlide
                key={slide.id}
                style={{
                  userSelect: "none",
                  background: lightMode ? "#ffffff" : "#343434",
                }}
              >
                {renderSlideContent(slide)}
              </SwiperSlide>
            ))
          )}
        </Swiper>

        {/* Custom Navigation Buttons */}
        <Box
          className="swiper-button-prev-custom"
          sx={{
            position: "absolute",
            top: 20,
            right: 60,
            zIndex: 10,
            width: 32,
            height: 32,
            borderRadius: "50%",
            backgroundColor: "rgba(255, 255, 255, 0.2)",
            backdropFilter: "blur(10px)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
            transition: "all 0.3s ease",
            "&:hover": {
              backgroundColor: "rgba(255, 255, 255, 0.3)",
              transform: "scale(1.1)",
            },
            "&::after": {
              content: '"❮"',
              color: "white",
              fontSize: "14px",
              fontWeight: "bold",
            },
          }}
        />

        <Box
          className="swiper-button-next-custom"
          sx={{
            position: "absolute",
            top: 20,
            right: 20,
            zIndex: 10,
            width: 32,
            height: 32,
            borderRadius: "50%",
            backgroundColor: "rgba(255, 255, 255, 0.2)",
            backdropFilter: "blur(10px)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
            transition: "all 0.3s ease",
            "&:hover": {
              backgroundColor: "rgba(255, 255, 255, 0.3)",
              transform: "scale(1.1)",
            },
            "&::after": {
              content: '"❯"',
              color: "white",
              fontSize: "14px",
              fontWeight: "bold",
            },
          }}
        />

        {/* Custom Pagination */}
        <Box
          sx={{
            position: "absolute",
            top: 20,
            left: 20,
            zIndex: 10,
            display: "flex",
            gap: 1,
            "& .swiper-pagination-bullet-custom": {
              width: 8,
              height: 8,
              borderRadius: "50%",
              backgroundColor: "rgba(255, 255, 255, 0.4)",
              cursor: "pointer",
              transition: "all 0.3s ease",
            },
            "& .swiper-pagination-bullet-active-custom": {
              backgroundColor: "rgba(255, 255, 255, 0.9)",
              transform: "scale(1.2)",
            },
          }}
        />
      </Card>

      <style jsx global>{`
        @keyframes rotate {
          from {
            transform: rotate(0deg);
          }
          to {
            transform: rotate(360deg);
          }
        }

        .swiper-pagination {
          position: absolute !important;
          top: 20px !important;
          left: 20px !important;
          width: auto !important;
          display: flex !important;
          gap: 8px !important;
        }
      `}</style>
    </Box>
  );
};

export default SliderTopArea;
